"use client";

import { useFormContext } from "../__chunks/PQKUBRVU.js";
import { useCollectionItem } from "../__chunks/SZHY72KI.js";
import "../__chunks/G4PVPWEW.js";
import { createElement, createHook, forwardRef, memo } from "../__chunks/7FZLUSKW.js";
import { useId, useMergeRefs } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/form/form-error.tsx
import { invariant } from "@ariakit/core/utils/misc";
import { useCallback, useRef } from "react";
var TagName = "div";
var useFormError = createHook(function useFormError2(_a) {
  var _b = _a,
    store = _b.store,
    nameProp = _b.name,
    getItemProp = _b.getItem,
    props = __objRest(_b, ["store", "name", "getItem"]);
  var context = useFormContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "FormError must be wrapped in a Form component.");
  var id = useId(props.id);
  var ref = useRef(null);
  var name = "".concat(nameProp);
  var getItem = useCallback(function (item) {
    var nextItem = __spreadProps(__spreadValues({}, item), {
      id: id || item.id,
      name: name,
      type: "error"
    });
    if (getItemProp) {
      return getItemProp(nextItem);
    }
    return nextItem;
  }, [id, name, getItemProp]);
  var children = store.useState(function () {
    var error = store == null ? void 0 : store.getError(name);
    if (error == null) return;
    if (!(store == null ? void 0 : store.getFieldTouched(name))) return;
    return error;
  });
  props = __spreadProps(__spreadValues({
    id: id,
    role: "alert",
    children: children
  }, props), {
    ref: useMergeRefs(ref, props.ref)
  });
  props = useCollectionItem(__spreadProps(__spreadValues({
    store: store
  }, props), {
    getItem: getItem
  }));
  return props;
});
var FormError = memo(forwardRef(function FormError2(props) {
  var htmlProps = useFormError(props);
  return createElement(TagName, htmlProps);
}));
export { FormError, useFormError };